import styled from "styled-components";

export const StyledMessageChip = styled.div<{ $color: string }>`
  border-radius: 30px;
  padding: 5px 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  background-color: ${({ $color: color }) => color};
`;
